import { Component } from '@opten/compiler/metadata/component';
import { Collapse } from '@opten/collapse/initializer';
import addClass from '@opten/dom/add-class';
import removeClass from '@opten/dom/remove-class';
import hasClass from '@opten/dom/has-class';
import debounce from '@opten/reactive/debounce';

@Component({ className: 'js-collapse' })
export class CollapseDefault {
	constructor(private element: HTMLElement) {
		const instance = new Collapse(element, {
			animateProp: 'height',
			dataToggleSelector: 'data-collapse',
		});
	}
}

export class CollapseResponsiveBase {
	private INSTANCE: Collapse;
	constructor(private el: HTMLElement) {
		this.init();
		window.addEventListener('resize', debounce(() => this.init(), 300));
	}

	get element(): HTMLElement {
		return this.el;
	}

	get instance(): Collapse {
		return this.INSTANCE;
	}

	public init() {
		if (window.innerWidth <= 991) {
			this.build();
		} else {
			this.destroy();
		}
	}

	public build() {
		this.INSTANCE = new Collapse(this.element, {
			animateProp: 'height',
			dataToggleSelector: 'data-collapse',
		});
	}

	public destroy() {
		if (this.INSTANCE) {
			this.INSTANCE.destroy();
		}
	}
}

@Component({ className: 'js-collapse-mobile' })
export class CollapseMobile extends CollapseResponsiveBase { }

@Component({ className: 'js-collapse-navigation' })
export class CollapseNavigation extends CollapseResponsiveBase {
	public build() {
		super.build();

		if (hasClass(document.body, 'is--navigation-open')) {
			super.instance.show();
		}
		super.element.addEventListener('show.opten.collapse', () => addClass(document.body, 'is--navigation-open'));
		super.element.addEventListener('hide.opten.collapse', () => removeClass(document.body, 'is--navigation-open'));
	}
}
